<template>

    <div class="outer-wrapper">

        <div class="card-wrap inner-wrapper" v-if=" [ 'android', 'windows phone', 'unknown' ].includes( currentDevice.toLowerCase() ) ">

            <h3>Android Users</h3>
            <p>

                click the " <span style="font-weight: bold;">&#8942;</span> " menu icon on the top right of your browser and select 'Add to Home Screen'
            </p>
        </div>
        <div class="card-wrap inner-wrapper" v-if=" [ 'ios', 'unknown' ].includes( currentDevice.toLowerCase() ) ">

            <h3>iOS Users</h3>
            <p>

                click the " <img src="../../../public/img/iosAction.png" style="width: 15px;height: 20px;"/> " menu icon on either the bottom or top of your browser ( if on iphone or ipad ) and scroll the bottom row of options to the right to reveal the 'Add to Home Screen' option
            </p>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {

        name: 'install-webapp',
        computed: {

            ...mapGetters({

                currentDevice : 'currentDevice'
            })
        }
    }
</script>

<style scoped>

    .outer-wrapper{

        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .inner-wrapper > p {

        font-size: 24px;
    }

</style>